import { ChevronDown, MapPin } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

// 后端帖子暂无学校字段，学校筛选暂不开放（避免选中后筛空所有内容）
const schools = ['全部学校']

interface SchoolSelectorProps {
  selectedSchool: string
  onSchoolChange: (school: string) => void
}

export function SchoolSelector({ selectedSchool, onSchoolChange }: SchoolSelectorProps) {
  return (
    <div className="flex items-center justify-between bg-white rounded-lg p-4 shadow-sm">
      <div className="flex items-center space-x-2">
        <MapPin className="w-5 h-5 text-orange-500" />
        <span className="text-sm text-gray-600">当前校区</span>
      </div>
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="flex items-center space-x-1 text-gray-900 font-medium">
            <span>{selectedSchool}</span>
            <ChevronDown className="w-4 h-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          {schools.map((school) => (
            <DropdownMenuItem
              key={school}
              onClick={() => onSchoolChange(school)}
              className={selectedSchool === school ? 'bg-orange-50 text-orange-600' : ''}
            >
              {school}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}